import * as React from "react";
import PropTypes from 'prop-types';

const SvgUrgencyPdpView = props => {
  if (props.id !== "_svgurgencypdpview") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 2 24 24" {...props}><path fill="#FFF" fillRule="evenodd" d="M20.895 11.819c.14.12.14.241 0 .362-.14.161-.274.302-.403.423-.128.12-.421.383-.877.785a9.752 9.752 0 01-1.437 1.057c-.502.302-1.08.624-1.735.967a9.571 9.571 0 01-2.138.8 9.59 9.59 0 01-2.314.287c-.91 0-1.84-.151-2.787-.453-.946-.303-1.734-.629-2.365-.981a15.952 15.952 0 01-1.946-1.3c-.666-.512-1.086-.855-1.263-1.026a17.483 17.483 0 01-.542-.559c-.117-.1-.117-.222 0-.362.187-.202.368-.388.542-.559.177-.17.597-.514 1.263-1.027a16.174 16.174 0 011.946-1.299c.63-.352 1.419-.678 2.365-.98a9.118 9.118 0 012.787-.454c.912 0 1.835.146 2.77.438.934.291 1.74.63 2.418 1.011.678.384 1.315.801 1.911 1.254.596.453 1.028.81 1.296 1.072.27.263.439.443.509.544M12 15c.833 0 1.542-.291 2.126-.875A2.896 2.896 0 0015 12c0-.834-.292-1.542-.874-2.125C13.542 9.29 12.833 9 12 9s-1.542.291-2.125.875C9.29 10.458 9 11.166 9 12c0 .834.291 1.542.875 2.125A2.89 2.89 0 0012 15m2.25-3c0 .62-.22 1.15-.66 1.59-.44.44-.97.66-1.59.66-.62 0-1.15-.22-1.59-.66-.44-.44-.66-.97-.66-1.59 0-.62.22-1.15.66-1.59.44-.44.97-.66 1.59-.66.62 0 1.15.22 1.59.66.44.44.66.97.66 1.59" /></svg>;
};

SvgUrgencyPdpView.displayName = "_svgurgencypdpview";
SvgUrgencyPdpView.propTypes = {
  id: PropTypes.string
};
SvgUrgencyPdpView.defaultProps = {
  id: ''
};
export default SvgUrgencyPdpView;